import { useEffect } from 'react';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { DefaultErrorBoundary, OptimusProvider, QueryBoundary } from '@mews-commander/ui';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { createAction } from '@mews/framework';
import { TabContent } from '../components/reservationDocumentsTab';

export const ReservationContractsTab = ({ reservationId }: { reservationId: string }) => {
    const dispatch = useCommanderThunkDispatch();
    const { data } = useRepositorySuspenseQuery('reservations', 'getAll', { reservationIds: [reservationId] });
    const groupId = data?.reservations?.[0]?.groupId;

    useEffect(() => {
        dispatch(createAction('reservationModule/CHANGE_TAB', 'contracts', { scope: groupId }));
    }, [groupId, dispatch, reservationId]);

    return (
        <OptimusProvider density="spacious">
            <DefaultErrorBoundary>
                <QueryBoundary loader="inline">
                    <TabContent groupId={groupId} />
                </QueryBoundary>
            </DefaultErrorBoundary>
        </OptimusProvider>
    );
};
